import { gql } from 'apollo-boost';
import { INTERACTIVE_MESSAGE_FIELDS } from '../../fragments/message/interactive-message-fields';

const REVIEW_FIELDS = `
            id
            localDate
            timezone
            period
            periodKey
            generationModel
            generationProvider
            analysisVersion
            evidenceCoverage { eligible included omitted }
            evidence {
                messageId depth selectedForDeepReading mediaInspected sourceTextUnavailable
                sources { kind field totalChars includedChars ranges { startChar endChar } }
            }
            headline
            story { kind title body messageIds sources { messageId title path } }
            summary
            sections {
                savedMessageIds
                savedCount
                stackBreakdown {
                    stackId
                    title
                    count
                }
                movesMade {
                    messageId
                    folderId
                    folderTitle
                }
                suggestions {
                    messageId
                    suggestedFolderId
                    suggestedFolderTitle
                    title
                    modelConfidence
                    message {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                }
                folderProposals {
                    title
                    messageIds
                    messages {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                }
                groupingProposals {
                    rootMessageId
                    memberMessageIds
                    reason
                    rootMessage {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                    memberMessages {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                }
                duplicateProposals {
                    canonicalUrl
                    rootMessageId
                    duplicateMessageIds
                    count
                    rootMessage {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                    duplicateMessages {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                }
                readingPicks {
                    messageId
                    title
                    sourceHost
                    url
                    description
                    message {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                }
                openTasks {
                    messageId
                    caption
                    message {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                }
                themes {
                    entityName
                    entityType
                    count
                    messageIds
                    messages {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                }
            }
            childReviewIds
            coverage {
                expected
                present
            }
            pipelineVersion
            generatedAt
            emailSentAt
            viewedAt
            status
            createdAt
            updatedAt
`;

export const GET_REVIEW = gql`
    query($id: ID!) {
        getReview(id: $id) {
            ${REVIEW_FIELDS}
        }
    }
`;

export const GET_REVIEW_BY_PERIOD = gql`
    query($data: GetReviewByPeriodInput!) {
        getReviewByPeriod(data: $data) {
            ${REVIEW_FIELDS}
        }
    }
`;
